import { Component, HostListener, ElementRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-apps-launcher',
  templateUrl: './apps-launcher.component.html',
  styleUrls: ['./apps-launcher.component.css']
})
export class AppsLauncherComponent {
  isOpen = false;
  loading = false;
  error: string | null = null;

  constructor(private _auth: AuthService, private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.error = null;
  }

  close() {
    this.isOpen = false;
    this.error = null;
  }

  openRewards() {
    if (this.loading) return;
    this.loading = true;
    this.error = null;

    this._auth.requestSsoTicket().subscribe({
      next: (res: any) => {
        const ticket = res.ticket;
        const url = `${(environment as any).REWARDS_FRONT_URL}/sso#ticket=${ticket}`;
        window.open(url, '_blank', 'noopener,noreferrer');
        this.loading = false;
        this.close();
      },
      error: (err: any) => {
        console.error('[AppsLauncher] Error:', err);
        this.error = 'No se pudo abrir Rewards';
        this.loading = false;
      }
    });
  }
}
